import { Link } from "react-router-dom";
import { ArrowLeft, LogOut, ShieldCheck, Sun, Moon, UserCircle } from "lucide-react";
import { FluxMark } from "../flux/Decor";

const display = "font-display";

export function triggerPanicRedirect() {
  window.location.replace("https://www.google.com");
}

function PlanBadge({ access }) {
  const styles = {
    admin: "text-[#f59e0b] border-[#f59e0b]/30 bg-[#f59e0b]/10",
    unlimited: "text-[#2dd4bf] border-[#2dd4bf]/30 bg-[#2dd4bf]/10",
    free: "text-[#2dd4bf] border-[#2dd4bf]/30 bg-[#2dd4bf]/10",
    weekly: "text-emerald-400 border-emerald-400/30 bg-emerald-400/10",
    trial: "text-blue-400 border-blue-400/30 bg-blue-400/10",
    expired: "text-rose-400 border-rose-400/30 bg-rose-400/10",
  };
  const label = {
    admin: "ALL-ACCESS ADMIN",
    unlimited: "UNLIMITED",
    free: "FREE ACCESS",
    weekly: `WEEKLY PASS · ${access.days_left}d left`,
    trial: `FREE TRIAL · ${access.days_left}d left`,
    expired: "TRIAL ENDED",
  };
  return (
    <span data-testid="plan-badge" className={`text-[9px] font-mono font-bold px-2 py-1 rounded-lg border whitespace-nowrap ${styles[access.plan]}`}>
      {label[access.plan]}
    </span>
  );
}

export default function MatrixNav({ user, onLogout, theme, onToggleTheme }) {
  return (
    <nav className="border-b border-white/5 bg-[#0f1729]/80 backdrop-blur px-4 sm:px-6 py-3 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-1.5 sm:gap-3 min-w-0">
          <Link to="/" data-testid="back-to-landing-link" className="text-gray-400 hover:text-[#f59e0b] transition-colors duration-200 shrink-0">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <FluxMark className="w-7 h-7 flex-shrink-0" />
          <span className={`${display} font-bold text-base tracking-wider uppercase text-white hidden lg:inline`}>
            FLU<span className="text-[#f59e0b]">X</span> <span className="font-normal text-gray-300">CAPACITOR</span>
          </span>
          <span className="hidden sm:inline"><PlanBadge access={user.access} /></span>
          {user.role === "admin" && (
            <Link to="/admin" data-testid="admin-link" title="Admin" className="flex items-center gap-1 text-[9px] font-mono font-bold text-gray-300 hover:text-[#f59e0b] border border-white/10 px-2 py-1 rounded-lg transition-colors duration-200 shrink-0">
              <ShieldCheck className="w-3 h-3" /> <span className="hidden sm:inline">ADMIN</span>
            </Link>
          )}
          <Link to="/account" data-testid="account-link" title="Account" className="flex items-center gap-1 text-[9px] font-mono font-bold text-gray-300 hover:text-[#f59e0b] border border-white/10 px-2 py-1 rounded-lg transition-colors duration-200 shrink-0">
            <UserCircle className="w-3 h-3" /> <span className="hidden sm:inline">ACCOUNT</span>
          </Link>
        </div>
        <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
          <button
            onClick={onToggleTheme}
            data-testid="theme-toggle-btn"
            title={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
            className="text-gray-300 hover:text-[#f59e0b] border border-white/10 p-2 rounded-xl transition-colors duration-200"
          >
            {theme === "light" ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
          </button>
          <button
            onClick={triggerPanicRedirect}
            data-testid="panic-override-btn"
            className="bg-rose-600/90 hover:bg-rose-600 text-white font-mono text-[10px] font-bold px-2.5 sm:px-3 py-2 rounded-xl border border-rose-500/30 transition-colors duration-150 shadow-lg active:scale-95 whitespace-nowrap"
          >
            <span className="hidden md:inline">PANIC OVERRIDE: CLOAK (OR HIT 'ESC')</span>
            <span className="md:hidden">PANIC</span>
          </button>
          <button onClick={onLogout} data-testid="logout-btn" title={`Sign out ${user.email}`} className="text-gray-400 hover:text-white border border-white/10 p-2 rounded-xl transition-colors duration-200">
            <LogOut className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </nav>
  );
}
